<script lang="ts">
    import { _ } from 'svelte-i18n';

    import IconTimeWindow from '../../shared/Icons/IconTimeWindow.svelte';
    import { TimeWindow, type TimeWindowType } from './TimeWindow';
    import Duration from '../../shared/Duration.svelte';

    export let timeWindow: TimeWindow | null = null;
    export let scale: number = 0.5;
    export let showDiff: boolean = false;

    let isError: boolean = false;

    let diff: number = 0;
    let title: string = '';

    $: {
        if (timeWindow) {

            diff = 0;

            let tw: TimeWindowType = timeWindow.getTimeWindow();

            if (timeWindow.isValid()) {
                let delivered = tw.delivered ? 'delivered_' : '';
                if (timeWindow.isFulfilled()) {
                    title = $_(
                        'timewindow_' +
                            delivered +
                            (!tw.to ? 'after_' : !tw.from ? 'before_' : '') +
                            'fulfilled_extended',
                        { values: tw }
                    );
                } else {
                    diff = timeWindow.getDifference();
                    if (diff < 0) {
                        title = $_(
                            'timewindow_' +
                                delivered +
                                (!tw.to ? 'after_' : '') +
                                'unfulfilled_extended',
                            { values: tw }
                        );
                    } else {
                        title = $_(
                            'timewindow_' +
                                delivered +
                                (!tw.from ? 'before_' : '') +
                                'unfulfilled_extended',
                            { values: tw }
                        );
                    }
                }
            } else {
                isError = true;
            }
        }
    }
</script>

{#if !isError && timeWindow}
    <svelte:component this={timeWindow.getColorComponentGlobal()}>
        <IconTimeWindow {scale} {title} />
    </svelte:component>
    {#if showDiff && diff}
        <span class="difference" {title}>
            <Duration
                seconds={diff * 60}
                warningAbove={0}
                errorAbove={15 * 60}
                warningBelow={0}
                errorBelow={-15 * 60}
                showSign={true}
                showExclamation={false}
            />
        </span>
    {/if}
{/if}

<style>
    .difference {
        display: inline-block;
        margin-left: 3px;
    }
</style>
